import React, { useEffect, useState } from "react";
import {Box, Typography, IconButton, Switch, CircularProgress, Drawer} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DisplayAdsCampaignEditor from "../DisplayAdsCampaignEditor";
import './DisplayAdsSlideOutPanel.scss';
import { assignDetails } from "../displayAdsFormComponent/Utils/assignDetails";
import {  saveCampaignSettings } from "./Utils/campaignSettingsApi";
import { saveAdsCreative } from "./Utils/campaignAdsCreativeApi";
import { updateCampaignStatus } from "./Utils/updateCampaignStatus";

const DisplayAdsSlideOutPanel = ({ isOpen, onClose, idAccount, idHotel, idCampaign, triggerAlert }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [campaignName, setCampaignName] = useState("");
    const [finalURL, setFinalURL] = useState('');
    const [landscape, setLandscape] = useState([]);
    const [logo, setLogo] = useState([]);
    const [isCampaignPaused, setIsCampaignPaused] = useState(false);
    const [errors, setErrors] = useState({});
    const [currencySymbol, setCurrencySymbol] = useState('€');
    
    const handleToggle = async () => {
        const newStatus = isCampaignPaused ? "ENABLED" : "PAUSED";
        setDrawerOpen(true);

        try {
            await updateCampaignStatus({ campaign_id: idCampaign, campaign_status: newStatus });
            setIsCampaignPaused((prev) => !prev);
            triggerAlert("success", `Campaign ${newStatus.toLowerCase()} successfully!`);
        } catch (error) {
            triggerAlert("error", "Failed to update campaign status. Please try again.");
        } finally {
            setDrawerOpen(false);
        }
    };

    useEffect(() => {
        assignDetails({
            isOpen,
            idCampaign,
            setDrawerOpen,
            setCampaignName,
            setSelectedLanguage,
            setFinalURL,
            setIsCampaignPaused,
            setLandscape,
            setLogo,
            setCurrencySymbol
        });
        setErrors({})
    }, [isOpen, idCampaign]);

    const createCampaignSettingsPayload = () => ({
        campaign_name: campaignName,
        campaign_lang: selectedLanguage,
    });

    const createAdsCreativePayload = () => ({
      final_url: {url: finalURL},
      marketing_image: landscape.map(l => ({assetContent: l})),
      logo_image: logo.map(l => ({assetContent: l}))
  });

    const onSaveSettings = async () => {
        setDrawerOpen(true);
        const payload = {
            campaign_id: idCampaign,
            campaign_settings: createCampaignSettingsPayload(),
        }
        const adsCreativePayload = {
            campaign_id: idCampaign,
            campaign_ads_creative: createAdsCreativePayload(),
        }

        try {
            await saveCampaignSettings(payload);
            await saveAdsCreative(adsCreativePayload);
            triggerAlert("success", "Campaign settings saved successfully !");
        } catch (error) {
            setErrors(error.errors);
        } finally {
            setDrawerOpen(false);
        }
    };

    return (
        <>
        {isOpen && !drawerOpen && (
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1100,
                }}
            />
        )}

    {/* Panneau latéral */}
    <Box className={`DisplayAdsSlideOutPanel ${isOpen ? "open" : ""}`}>
        <Box className="header" style={{ display: "flex", justifyContent: "space-between" }}>
            <Box style={{ display: "flex", alignItems: "center" }}>
                <IconButton onClick={onClose} className="closeButton">
                    <CloseIcon fontSize="small" />
                </IconButton>
                <Typography variant="body1" className="title">Edit Campaign</Typography>
            </Box>
            <Box style={{ display: "flex", alignItems: "center" }}>
                <Switch
                    checked={isCampaignPaused}
                    onChange={handleToggle}
                    color="primary"
                    inputProps={{ "aria-label": "Pause Campaign Toggle" }}
                />
                <Typography variant="body2" className="pause-toggle-title">Pause Campaign</Typography>
            </Box>
        </Box>

        <Box className="content">
            <DisplayAdsCampaignEditor
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
                campaignName={campaignName}
                setCampaignName={setCampaignName}
                finalURL={finalURL}
                setFinalURL={setFinalURL}
                isEdit={true}
                landscape={landscape}
                setLandscape={setLandscape}
                logo={logo}
                setLogo={setLogo}
                idAccount={idAccount}
                idHotel={idHotel}
                setDrawerOpen={setDrawerOpen}
                idCampaign={idCampaign}
                errors={errors}
                onCreateCampaign={() => {
                 onSaveSettings();
                }}
                onCancel={onClose}
            />
        </Box>
        <Drawer
            anchor="top"
            open={drawerOpen}
            PaperProps={{
                sx: {
                    background: "transparent"
                },
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <CircularProgress size={60} color="primary" />
            </Box>
        </Drawer>
    </Box>
</>
    );
};

export default DisplayAdsSlideOutPanel;
